<div *ngIf="hintText() as hint" class="mb-20 text-14 text-light-1">
  <i class="icon-info text-14 mr-5"></i>{{ hint }}
</div>

<div class="installment-section mb-30" *ngIf="show()">
  <div class="d-flex items-center mb-15">
    <img src="assets/maximum@2x.png" alt="Maximum" class="installment-logo">
    <span class="text-16 fw-600 text-dark-1 ml-10">Taksit Seçenekleri</span>
  </div>
  <div class="installment-list">
    <label *ngFor="let opt of options()"
      class="installment-option"
      [class.installment-option--active]="selectedCount() === opt.count">
      <input type="radio" name="installmentSelector"
        [value]="opt.count"
        [checked]="selectedCount() === opt.count"
        (change)="selectInstallment(opt.count)">
      <span class="installment-radio"></span>
      <span class="installment-label">{{ opt.label }}</span>
      <span class="installment-amount" *ngIf="opt.count > 1 && totalPrice() > 0">
        {{ (totalPrice() / opt.count | number:'1.2-2':'tr') }} TL x {{ opt.count }}
      </span>
    </label>
  </div>
</div>
